// // // src/Components/Tour/registerStaticSteps.tsx
// // import React, { useEffect } from "react";
// // import { useTour } from "../../context/TourContext";

// // export default function RegisterStaticSteps() {
// //   const { registerStep, unregisterStep } = useTour();
// //   useEffect(() => {
// //     const id = "book-reviews-first-step";
// //     registerStep({
// //       id,
// //       target: '[data-tour="my-book-reviews"]',
// //       content: (
// //         <div>
// //           <strong className="bg-light text-dark">Welcome to your book review/s.</strong>
// //           <div className="text-dark" style={{ marginTop: 6 }}>
// //             Select the <em>Book Review</em> label on the left to get started.
// //           </div>
// //         </div>
// //       ),
// //       position: "right",
// //       order: 0,
// //     });

// //     return () => unregisterStep(id);
// //   }, [registerStep, unregisterStep]);

// //   return null;
// // }



// // src/Components/Tour/registerStaticSteps.tsx
// import React, { useEffect } from "react";
// import { useTour } from "../../context/TourContext";

// export default function RegisterStaticSteps() {
//   const { registerStep, unregisterStep } = useTour();
//   useEffect(() => {
//     const id = "book-reviews-first-step";

//     // helper to detect dark mode based on body class (your app adds 'dark-only')
//     const isDark = () => typeof document !== "undefined" && document.body.classList.contains("dark-only");

//     // base colors inspired by ManageUsers component
//     const ACCENT = "#FF3500";
//     const lightBg = "#ffffff";
//     const lightText = "#111827"; // dark gray/near-black
//     const lightNote = "#FF3500"; // same as accent for the note text in light theme

//     const darkBg = "#111827"; // deep dark background
//     const darkText = "#E5E7EB"; // light gray text
//     const darkNote = "#FF8A66"; // slightly lighter orange for contrast on dark

//     const content = () => {
//       const dark = isDark();
//       const containerStyle: React.CSSProperties = {
//         background: dark ? darkBg : lightBg,
//         color: dark ? darkText : lightText,
//         borderRadius: 8,
//         padding: 12,
//         maxWidth: 320,
//         boxShadow: dark ? '0 8px 24px rgba(0,0,0,0.6)' : '0 6px 18px rgba(0,0,0,0.08)',
//         border: dark ? '1px solid rgba(255,255,255,0.04)' : '1px solid rgba(0,0,0,0.06)',
//         fontSize: 14,
//         lineHeight: 1.4,
//       };

//       const headingStyle: React.CSSProperties = {
//         display: 'block',
//         fontWeight: 700,
//         color: dark ? darkNote : ACCENT,
//         marginBottom: 6,
//         fontSize: 15,
//       };

//       const paragraphStyle: React.CSSProperties = {
//         color: dark ? darkText : lightText,
//         margin: 0,
//       };

//       const noteIconStyle: React.CSSProperties = {
//         display: 'inline-block',
//         verticalAlign: 'middle',
//         marginRight: 8,
//         width: 18,
//         height: 18,
//         lineHeight: '18px',
//         textAlign: 'center',
//         color: dark ? darkNote : ACCENT,
//         background:"#FF3500"
//       };

//       return (
//         <div style={containerStyle}>
//           <div style={{ display: 'flex', alignItems: 'flex-start' }}>
//             <div style={noteIconStyle} aria-hidden>
//               {/* small info icon similar to ManageUsers alert */}
//               <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden>
//                 <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 12.93A5.93 5.93 0 1 1 8 2.07a5.93 5.93 0 0 1 0 11.86z"/>
//                 <path d="M8.93 6.588a.5.5 0 0 0-.858-.514L7.5 7.42 7.042 6.074a.5.5 0 0 0-.884.468l.8 2a.5.5 0 0 0 .94.008l.99-2.382zM8 11a.9.9 0 1 0 0-1.8A.9.9 0 0 0 8 11z"/>
//               </svg>
//             </div>

//             <div style={{ flex: 1 }}>
//               <span style={headingStyle}>Welcome to your book review/s.</span>
//               <p style={paragraphStyle}>
//                 Select the <strong style={{ color: dark ? darkNote : ACCENT }}>My Book Reviews</strong> label to get started.
//               </p>
//             </div>
//           </div>
//         </div>
//       );
//     };

//     registerStep({
//       id,
//       target: '[data-tour="my-book-reviews"]',
//       content: content(),
//       position: "right",
//       order: 0,
//     });

//     return () => unregisterStep(id);
//   }, [registerStep, unregisterStep]);

//   return null;
// }

// src/Components/Tour/registerStaticSteps.tsx
import React, { useEffect } from "react";
import { useTour } from "../../context/TourContext";

/**
 * Registers the static tour steps:
 *  - book-reviews-first-step  (sidebar)  [order: 0]
 *  - review-list-tabs-step     (tabs row) [order: 1]
 *
 * If you already registered step 1 elsewhere, this will re-register it during mount
 * and unregister on unmount (harmless). Keeping a single canonical registration is fine.
 */

export default function RegisterStaticSteps() {
  const { registerStep, unregisterStep } = useTour();

  useEffect(() => {
    const ACCENT = "#FF3500";

    const isDark = () =>
      typeof document !== "undefined" && document.body.classList.contains("dark-only");

    const lightBg = "#ffffff";
    const lightText = "#111827";

    const darkBg = "#111827";
    const darkText = "#E5E7EB";
    const darkNote = "#FF8A66";

    // --- Step 1: Book Reviews sidebar item ---
    const step1Content = (() => {
      const dark = isDark();
      const containerStyle: React.CSSProperties = {
        background: dark ? darkBg : lightBg,
        color: dark ? darkText : lightText,
        borderRadius: 8,
        padding: 12,
        maxWidth: 320,
        boxShadow: dark ? "0 8px 24px rgba(0,0,0,0.6)" : "0 6px 18px rgba(0,0,0,0.08)",
        border: dark ? "1px solid rgba(255,255,255,0.04)" : "1px solid rgba(0,0,0,0.06)",
        fontSize: 14,
        lineHeight: 1.4,
      };
      const headingStyle: React.CSSProperties = {
        display: "block",
        fontWeight: 700,
        color: dark ? darkNote : ACCENT,
        marginBottom: 6,
        fontSize: 15,
      };
      const paragraphStyle: React.CSSProperties = {
        color: dark ? darkText : lightText,
        margin: 0,
      };

      return (
        <div style={containerStyle}>
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <div style={{ display: "inline-block", marginRight: 8, width: 18, height: 18, color: dark ? darkNote : ACCENT }} aria-hidden>
              <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 12.93A5.93 5.93 0 1 1 8 2.07a5.93 5.93 0 0 1 0 11.86z"/>
                <path d="M8.93 6.588a.5.5 0 0 0-.858-.514L7.5 7.42 7.042 6.074a.5.5 0 0 0-.884.468l.8 2a.5.5 0 0 0 .94.008l.99-2.382zM8 11a.9.9 0 1 0 0-1.8A.9.9 0 0 0 8 11z"/>
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <span style={headingStyle}>Welcome to your book review/s.</span>
              <p style={paragraphStyle}>
                Select the <strong style={{ color: isDark() ? darkNote : ACCENT }}>Book Review</strong> label on the left to get started.
              </p>
            </div>
          </div>
        </div>
      );
    })();

    const step1 = {
      id: "book-reviews-first-step",
      target: '[data-tour="my-book-reviews"]',
      content: step1Content,
      position: "right" as const,
      order: 0,
    };

    // --- Step 2: Upcoming / Active / Completed tabs ---
    const step2Content = (() => {
      const dark = isDark();
      const containerStyle: React.CSSProperties = {
        background: dark ? darkBg : lightBg,
        color: dark ? darkText : lightText,
        borderRadius: 8,
        padding: 12,
        maxWidth: 360,
        boxShadow: dark ? "0 8px 24px rgba(0,0,0,0.6)" : "0 6px 18px rgba(0,0,0,0.08)",
        border: dark ? "1px solid rgba(255,255,255,0.04)" : "1px solid rgba(0,0,0,0.06)",
        fontSize: 14,
        lineHeight: 1.4,
      };
      const headingStyle: React.CSSProperties = {
        display: "block",
        fontWeight: 700,
        color: dark ? darkNote : ACCENT,
        marginBottom: 6,
        fontSize: 15,
      };
      const paragraphStyle: React.CSSProperties = {
        color: dark ? darkText : lightText,
        margin: 0,
      };

      return (
        <div style={containerStyle}>
        {/* <div> */}
          <div>
            <span style={headingStyle}>Filter your reviews</span>
            <p style={paragraphStyle}>
              You will find your{" "}
              <strong style={{ color: dark ? darkNote : ACCENT }}>upcoming</strong>,{" "}
              <strong style={{ color: dark ? darkNote : ACCENT }}>active</strong>, or{" "}
              <strong style={{ color: dark ? darkNote : ACCENT }}>completed</strong> book review/s by
              selecting one of these buttons.
            </p>
          </div>
        </div>
      );
    })();

    const step2 = {
      id: "review-list-tabs-step",
      target: '[data-tour="review-list-tabs"]',
      content: step2Content,
      position: "bottom" as const,
      order: 1,
    };

    // Register both steps (if duplicates exist elsewhere, this will overwrite during mount; we unregister on unmount)
    registerStep(step1);
    registerStep(step2);

    return () => {
      try {
        unregisterStep(step1.id);
      } catch {}
      try {
        unregisterStep(step2.id);
      } catch {}
    };
  }, [registerStep, unregisterStep]);

  return null;
}
